import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

import FitFinder from './fitfinder';

ReactDOM.render(<FitFinder />, document.querySelector('#root'));